/**
 * 包含多个简介更新state的方法，对象模块
 * */ 
import {
    ADD_TODO,
    DELETE_TODO,
    SELECT_ALL_TODO,
    DELETE_FINISHED_TODO
} from './mutations-type'
export default {
    addTodo({commit},todo){
        commit(ADD_TODO,{todo});
    },
    delTodo({commit},index){
        commit(DELETE_TODO, {index});
    },
    selectedAllTodo({commit},isCheck){
        commit(SELECT_ALL_TODO,{isCheck});
    },
    delFinishedTodos({commit}, todo){
        commit(DELETE_FINISHED_TODO,{todo})
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js